export default __webpack_public_path__ + "static/media/ellipse-520.3435f106.svg";